import { Grid } from '@mui/material';
import type { DashboardCollationItem, DashboardInterview, DashboardMyAppraisal, DashboardTalentCommittee } from '@/api/dashboardApi';
import { Section, SectionHeader } from '@/components/common';
import { CollationSubsection } from './CollationSubsection';
import { MyAppraisalSubsection } from './MyAppraisalSubsection';
import { MyPlannedInterviewsSubsection } from './MyPlannedInterviewsSubsection';
import { TalentCommitteeSubsection } from './TalentCommitteeSubsection';

interface AppraisalsSectionProps {
  myAppraisal: DashboardMyAppraisal | null;
  collation: DashboardCollationItem[];
  plannedInterviews: DashboardInterview[];
  talentCommittees: DashboardTalentCommittee[];
}

export function AppraisalsSection({ myAppraisal, collation, plannedInterviews, talentCommittees }: AppraisalsSectionProps) {
  return (
    <Section>
      <SectionHeader>APPRAISALS</SectionHeader>
      <Grid container spacing={{ xs: 1 }}>
        <Grid size={{ xs: 12 }}>
          <MyAppraisalSubsection myAppraisal={myAppraisal} />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }} sx={{ minWidth: 0, display: 'flex' }}>
          <CollationSubsection collation={collation} />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }} sx={{ minWidth: 0, display: 'flex' }}>
          <MyPlannedInterviewsSubsection plannedInterviews={plannedInterviews} />
        </Grid>
        {talentCommittees.map((tc) => (
          <Grid
            key={tc.tcId}
            size={{ xs: 12, md: talentCommittees.length === 1 ? 12 : 6 }}
            sx={{ minWidth: 0, display: 'flex' }}
          >
            <TalentCommitteeSubsection tc={tc} />
          </Grid>
        ))}
      </Grid>
    </Section>
  );
}

export default AppraisalsSection;
